import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import messageActions from 'actions/messages/actions';

const MessageAccept = ({ acceptMessage, inquiryId, status }) => {
  return (
    <div className="text-center">
      {status === 'pending' && <div className="w-1/2 mb-3 m-auto">
        <span className="mx-1 text-sm text-green-500 cursor-pointer" onClick={() => acceptMessage(inquiryId)}>ACCEPT</span>
        <span className="mx-1">|</span>
        <span className="mx-1 text-sm text-gray-600 cursor-default" onClick={() => console.log('Decline')}>DECLINE</span>
      </div>}
    </div>
  )
};

MessageAccept.propTypes = {
  acceptMessage: PropTypes.func,
  inquiryId: PropTypes.number,
  status: PropTypes.string
}
const mapDispatchToProps = {
  acceptMessage: messageActions.acceptMessage
}

export default connect(null, mapDispatchToProps)(MessageAccept);
